import { render, staticRenderFns } from "./ProfileTabChangePassword.vue?vue&type=template&id=29bb236e"
import script from "./ProfileTabChangePassword.vue?vue&type=script&lang=ts"
export * from "./ProfileTabChangePassword.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports